import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { expVal } from '@confluence/feature-experiments';
import { LoadableAfterPaint } from '@confluence/loadable';

const ConnectorDeepLinkLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConnectorDeepLink" */
				'./ConnectorDeepLink.tsx'
			)
		).ConnectorDeepLink,
});

/**
 * Global entry for the Confluence connector deep link, rendered once by
 * `GlobalComponents`. Gated behind the `confluence_universal_connector_modal_deeplink`
 * experiment so non-enrolled users never load the lazy chunk, and lazy-loaded so
 * the connector-modal code (incl. `RovoSettingsModal`) stays out of the main chunk.
 */
export const ConnectorDeepLinkComponentLoader = (): React.JSX.Element | null => {
	if (!expVal('confluence_universal_connector_modal_deeplink', 'isEnabled', false)) {
		return null;
	}

	return (
		<ErrorBoundary
			attribution={Attribution.AI_MATE}
			attributes={{
				errorBoundaryId: 'GlobalComponents-ConnectorDeepLink',
			}}
		>
			<ConnectorDeepLinkLoadable />
		</ErrorBoundary>
	);
};
